import React, { Component } from 'react';
import { Route } from 'react-router-dom';
// Components
import Card from '../../Components/Card/bigCard';
import ListEventsCards from './ListEvents';

// Styling
import Member from '../../Components/Profile/member'
import Menu from '../../Components/Menu/leftmenu'
import LogoutIcon from '../../static/images/logout.png'
import MyTickets from '../../Pages/MemberTickets'
import MyProfile from '../../Pages/Profile'
import {connect} from 'react-redux';

const getState = (state) =>{
    return{
        name:state.currentUser.name,
        number:state.currentUser.number,
    }
}

const Dispatch = (dispatch)=>{
    return{
        logout : () =>{
            let action = {
                type:'Logout'
            }
            dispatch(action)
        }
    }
}

class ListEvents extends Component {
    render() {
        return (
            <div className="container pt-6">
                <Card>
                    <div className="row row-card">
                        <div className="col-sm-3 border-right">
                            <div className="member-container">
                                <Member 
                                    image="http://www.link-wall.com/images/unknown_profile.png"
                                    name={this.props.name}
                                    memberNo={this.props.number}/>
                            </div>
                            <div className="menu-container pt-6">
                                <Menu />
                            </div>
                            <div className="logout-container">
                                <span className="logout" onClick={this.props.logout}><img style={{marginTop:'-2px'}} src={LogoutIcon} alt="Logout"/> Cerrar Sesión</span>
                            </div>
                        </div>
                        {/* <ListEventsCards /> */}
                        <Route path='/' exact component={ListEventsCards} />
                        <Route path='/tickets' component={MyTickets} />
                        <Route path='/profile' exact component={MyProfile} />
                    </div>
                </Card>
            </div>
        );
    }
}

export default connect(getState,Dispatch)(ListEvents);



// WEBPACK FOOTER //
// ./src/Pages/ListEvents/index.js